<template>
	<a
		class="button share-button"
		:class="classes"
		:href="link"
		target="_blank"
		rel="noopener"
	>
		<slot name="icon" />
		<span v-if="title">{{ title }}</span>
	</a>
</template>

<script>
export default {
	name:  'ShareButton',
	props: {
		title: {
			type:    String,
			default: null,
		},
		link: {
			type:     String,
			required: true,
		},
		classes: {
			type: Object,
		},
	},
};
</script>

<style lang="scss" scoped>

.share-button {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px 6px;
	min-width: 0;
	max-width: 120px;

	span {
		font-size: 14px;
		font-weight: bold;
	}

	.v2-icon::v-deep {
		margin-right: 4px;
	}
}

</style>
